import { render, staticRenderFns } from "./CustomBanners.vue?vue&type=template&id=18734292"
import script from "./CustomBanners.vue?vue&type=script&lang=ts"
export * from "./CustomBanners.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports